<link rel="alternate" type="application/rss+xml" title="RSS 2.0" href="https://uni.xyz/blogs/rss/" />
<uni-search 
  [showOptions]="false"
  placeholder="Search Journals on UNI"
  (searchedText)="goToSearchPage($event)">
</uni-search>
<ng-container *ngIf="blogTypes.length">
  <div fxLayout="row" class="relative margin-y-3">
  <section class="chip-section-wrapper width-100 overflow-hidden" fxLayout="row" #tabsContent
    [ngStyle]="{'padding': showScroll ? '0 60px' : '0'}">
    <div #chipSection fxLayout="row" fxLayoutGap="16px">
      <ng-container *ngFor="let blogType of blogTypes">
        <a [href]="blogType.id!=disciplineId ? (blogTypeUrl+blogType.slug) : journalUrl" class="no-decor" style="width: max-content;">
          <div fxLayout="row" fxLayoutAlign="center center" class="blog-type-chip" [class.active-blog-type]="blogType.id==disciplineId">
            <!-- <img *ngIf="blogType.icon" [src]="blogType?.icon" [alt]="blogType.name+' image'" class="fit-cover"> -->
            <uni-image *ngIf="blogType.icon"
              [src]="blogType?.icon" 
              [alt]="blogType.name+' image'"
              [height]= "48"
              [width]= "48"
              classes="border-radius-2 fit-cover">
            </uni-image>
            <p class="padding-x-1 margin-y-3 width-100">{{blogType.name}}</p>
          </div>
        </a>

        <!-- <div fxLayout="row" fxLayoutAlign="center center"  class="blog-type-chip" [class.active-blog-type]="blogType.id==disciplineId">
          <p class="padding-x-1 margin-0">{{blogType.name}}</p>
        </div> -->
      </ng-container>
    </div>
  </section>
  <div class="absolute cursor-pointer height-100" fxLayout="row" style="left: 0;" *ngIf="showScroll">
    <i class="icon-arrow-left" style="background: #f4f4f4;    font-size: 32px;
    line-height: 48px;" (click)="scroll('left')"></i>
    <div class="" style="background: linear-gradient(to right, rgba(244, 244, 244, 1) 46%, rgba(0, 0, 0, 0) 80%); width: 32px;"></div>
  </div>
  <div class="absolute cursor-pointer height-100" fxLayout="row" style="right: 0;" *ngIf="showScroll">
    <div class="" style="background: linear-gradient(to left, rgba(244, 244, 244, 1) 46%, rgba(0, 0, 0, 0) 80%); width: 32px;"></div>
    <i class="icon-arrow-right" style="background: #f4f4f4;    font-size: 32px;
    line-height: 48px;" (click)="scroll('right')"></i>
  </div>
</div>
</ng-container>

<ng-container *ngIf="isLoading; else viewTemplate">
  <div class="margin-y-5" fxLayout="row" fxLayoutGap="16px">
    <div class="section-bg width-100">
      <uni-skeleton-loader appearance="blog" [count]="8"></uni-skeleton-loader>
    </div>
    <div class="section-bg" style="width: 360px;" *ngIf="!tabView">
      <uni-skeleton-loader appearance="blog-featured" [count]="8"></uni-skeleton-loader>
    </div>
  </div>
  <div class="width-50 height-100 margin-x-auto loader-wrapper" fxHide.gt-sm fxLayout="column" fxLayoutAlign="center center">
    <uni-loader></uni-loader>
  </div>
</ng-container>

<ng-template #viewTemplate>
  <div style="display:flex; flex-direction: row; gap: 16px;">
    <div class="blog-section-wrapper width-100">
      <ng-container *ngFor="let editorialBlogsArray of editorialBlogs; let i=index; let last=last">
        <ng-container *ngIf="editorialBlogsArray.length">
          <div class="padding-3 section-bg">
            <ng-container *ngIf="i==0">
              <a [href]="blogCreateUrl" class="create-journal-section cursor-pointer margin-x-auto margin-bottom-8 width-100 no-decor" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="16px">
                <i class="icon-write-bold sparro-grey-800"></i>
                <p class="margin-0 font-bold font-md">Write a journal</p>
                <p class="margin-0 font-sm text-center">Share your design stories, news, press release, blog and get featured on UNI’s weekly editorial.</p>
              </a>
              <p class="margin-top-0 sparro-orange-600 text-center font-bold margin-bottom-2">Editorial Content</p>
              <p class="margin-0 text-center section-desc">Curated articles for you from UNI Community</p>
            </ng-container>
            <uni-blog-cards-group
              [blogs]="editorialBlogsArray"
              [self]="false"
              [host]="host"
              [showCardOptions]="true">
            </uni-blog-cards-group>
          </div>
          <div *ngIf="adsArray.length" class="bottom-margin">
            <uni-advertisement-card [advertisement]="adsArray[i % adsArray.length]"></uni-advertisement-card>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="allEditorialLoaded && tabView">
        <div class="bottom-margin">
          <uni-blog-featured-sidenav
            [feedFeatureBlogs]="featuredBlogs"
            [self]="false"
            [showCardOptions]="true"
            [horizaontalView]="true">
          </uni-blog-featured-sidenav>
        </div>
      </ng-container>
      <div *ngIf="blogs.length">
        <ng-container *ngFor="let blogsArray of blogs; let i=index">
          <ng-container *ngIf="blogsArray.length">
            <div class="padding-3 section-bg">
              <ng-container *ngIf="i==0">
                <p class="margin-top-0 text-center font-bold margin-bottom-2">Recently Published</p>
                <p class="margin-0 text-center section-desc">Recently published articles fresh from oven!!</p>
              </ng-container>
              <uni-blog-cards-group
                [blogs]="blogsArray"
                [self]="false"
                [host]="host"
                [showCardOptions]="true">
              </uni-blog-cards-group>
            </div>
            <ng-container *ngIf="adsArray.length">
              <uni-advertisement-card [advertisement]="adsArray[i % adsArray.length]"></uni-advertisement-card>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div *ngIf="!tabView">
      <div fxLayout="column" fxLayoutGap="16px" fxLayoutAlign="start center" style="width: 360px; position: sticky;" #sidenavContainer>
        <div class="width-100 section-bg" *ngIf="topSuperTags.length" style="padding: 20px; border: 1px solid #e6e6e6; width: calc(100% - 40px);">
          <div fxLayout="column" fxLayoutGap="16px">
            <p class="margin-0 font-bold">Topics to follow</p>
            <ng-container *ngFor="let superTag of topSuperTags">
              <a [href]="topicUrl+superTag.slug+'/journals'" class="no-decor">
                <div fxLayout="row" fxLayoutAlign="center center" class="supertag-chip">
                  <!-- <img *ngIf="superTag.icon" [src]="superTag.icon" [alt]="superTag.name+' image'" class="fit-cover"> -->
                  <uni-image *ngIf="superTag?.icon"
                    [src]="superTag?.icon" 
                    [alt]="superTag.name+' image'"
                    [height]= "48"
                    [width]= "48"
                    classes="border-radius-2 fit-cover">
                  </uni-image>
                  <i *ngIf="!superTag.icon" class="icon-discipline font-lg" fxLayout="row" fxLayoutAlign="center center" style="width: 48px; height: 48px;"></i>
                  <p class="padding-x-1 width-100 margin-0 font-bold">{{superTag.name}}</p>
                </div>
              </a>
            </ng-container>
          </div>
        </div>
        <div class="section-bg" *ngIf="competitions.length" style="border: 1px solid #e6e6e6;">
          <p class="margin-0 font-bold" style="padding: 20px 20px 0;">Call for articles</p>
          <uni-competition-cards-group [competitions]="competitions"></uni-competition-cards-group>
        </div>
        <uni-blog-featured-sidenav
          [feedFeatureBlogs]="featuredBlogs?.slice(0,2)"
          [self]="false"
          [showCardOptions]="true">
        </uni-blog-featured-sidenav>
        <a href="https://news.google.com/publications/CAAqBwgKMPubqAsw6KbAAw?hl=en-IN&gl=IN&ceid=IN:en" 
            target="_blank" class="no-decor padding-right-2 follow-button overflow-hidden width-100" 
            fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
            <img src="https://uni-common-assets.s3.us-east-1.amazonaws.com/logo/google-news.svg"
              alt="google-news-logo" width="72px" height="72px">
            <p class="margin-0 font-bolder width-100">Follow us on Google News</p>
            <i class="icon-open-in-new-tab-bold"></i>
          </a>
        <div *ngIf="adsArray.length" style="max-width: 360px;">
          <uni-advertisement-card [advertisement]="adsArray[0]"></uni-advertisement-card>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<div class="load-more-wrapper" fxLayout="row" fxLayoutAlign="center center">
  <div style="height:200px;" *ngIf="showSpinner" fxLayout="row" fxLayoutAlign="center center">
    <uni-loader></uni-loader>
  </div>
</div>

<uni-public-footer [seoContent]="seoContent"></uni-public-footer>